"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var apps_enum_exports = {};
__export(apps_enum_exports, {
  AppsList: () => AppsList,
  getAppFrom: () => getAppFrom,
  getApps: () => getApps
});
module.exports = __toCommonJS(apps_enum_exports);
var AppsList = {
  affirm: {
    key: "affirm",
    label: "Affirm",
    urlIcon: "app_icon_affirm.png",
    url: "/auth/launch/affirm"
  },
  um: {
    key: "um",
    label: "User management",
    urlIcon: "app_icon_um.png",
    url: "/auth/launch/eureka-math-navigator"
  },
  em: {
    key: "em",
    label: "Eureka Math Navigator",
    urlIcon: "app_icon_em.png",
    url: "/auth/launch/in-sync"
  },
  ww: {
    key: "ww",
    label: "Wit & Wisdom Digital TE",
    urlIcon: "app_icon_ww.png",
    url: "/auth/launch/inkling"
  },
  phd: {
    key: "phd",
    label: "PhD Science Digital TE",
    urlIcon: "app_icon_phd.png",
    url: "/auth/launch/inkling"
  }
};
function getApps() {
  return [AppsList.affirm, AppsList.um, AppsList.em, AppsList.ww, AppsList.phd];
}
function getAppFrom(value) {
  return getApps().find(function(app) {
    return app.key === value;
  });
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AppsList,
  getAppFrom,
  getApps
});
//# sourceMappingURL=apps.enum.js.map